import { memo } from 'react';

import { WorkspaceAgentThumbnailRowItem } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/cards/WorkspaceAgentThumbnailRowItem';
import { type WorkspaceAgentThumbnail } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/cards/workspaceAgentThumbnailTypes';

export type WorkspaceAgentThumbnailRowProps = {
  'data-testid'?: string;
  onOpen?: (id: string) => void;
  thumbnails: WorkspaceAgentThumbnail[];
};

/**
 * The clips behind a finding, scrolled horizontally rather than wrapped: the panel is narrow enough
 * that wrapping would push the rest of the message off the screen.
 *
 * Each cell is padded so a focus ring has room to draw inside the scroll container. The row pulls back
 * only part of that padding (2px against 4px), which keeps the cards from looking inset while leaving
 * the ring on the first and last card clear of the container edge.
 */
export const WorkspaceAgentThumbnailRow = memo(
  ({ 'data-testid': testId, onOpen, thumbnails }: WorkspaceAgentThumbnailRowProps) => (
    <div className="-mx-0.5 flex items-start overflow-x-auto" data-testid={testId}>
      {thumbnails.map((thumbnail) => (
        <WorkspaceAgentThumbnailRowItem key={thumbnail.id} onOpen={onOpen} thumbnail={thumbnail} />
      ))}
    </div>
  ),
);

WorkspaceAgentThumbnailRow.displayName = 'WorkspaceAgentThumbnailRow';
